import dayjs, { Dayjs } from 'dayjs';

export const MAX_CPP_EXP_DAYS = 730;
export const CUSTOM_LABEL = 'Set Custom Expiration Date';
export const TODAY_DATE = new Date();
export const TOMORROW_DATE = dayjs(TODAY_DATE).add(1, 'day');
export const MAX_DATE = dayjs(TODAY_DATE).add(MAX_CPP_EXP_DAYS, 'day');
export const DEFAULT_CPP_LENGTH_DAYS = 90;
export const CPP_LENGTH_LIST = [
  {
    label: '30 Days',
    value: 30,
  },
  {
    label: '60 Days',
    value: 60,
  },
  {
    label: '90 Days',
    value: 90,
  },
  {
    label: '180 Days',
    value: 180,
  },
  { label: CUSTOM_LABEL, value: 1 },
];

export function getCppLengthList(baseDate: Date | Dayjs | null = TODAY_DATE) {
  return CPP_LENGTH_LIST.map((item) => {
    return {
      label: item.label,
      value: dayjs(baseDate).add(item.value, 'day'),
      daysAmount: item.value,
    };
  });
}

export function getCppOptionFromList(list: ReturnType<typeof getCppLengthList>, days: number) {
  return list.find((item) => item.daysAmount === days);
}
